module.exports = __webpack_public_path__ + "img/KSC03068.ae9d9530.jpg";